import Vue from 'vue'
import Vuex from 'vuex'
import isEmpty from 'lodash/isEmpty'

import menu from '@/store/modules/menu'
import secret from '@/store/modules/secret'
import projects from '@/store/modules/projects'
import manifest from '@/store/modules/manifest'
import work from '@/store/modules/work'

Vue.use(Vuex)

const getters = {
  isLoading ({ manifest, projects }) {
    return !manifest.background && isEmpty(projects.items)
  }
}

export default new Vuex.Store({
  modules: {
    menu,
    secret,
    projects,
    manifest,
    work
  },
  getters
})



// WEBPACK FOOTER //
// ./src/store/index.js